__turbopack_context__.v({
  "className": "public_sans_7594adb-module__G-fR1a__className",
});
